module.exports = __webpack_public_path__ + "images/feed-thankse1817300aa00df55aabd98c0ccbddc40.svg";